import MellowMark from '../../../../../toolkit/core-kit/assets/mellow-mark.svg?react';

import LoadingMask from './LoadingMask';
import styles from './index.module.scss';

export { default as LoadingIcon } from './LoadingIcon';
export { default as LoadingMask } from './LoadingMask';

export const LoadingIconWithContainer = () => (
  <div className={styles.container} role="status" aria-label="Loading">
    <MellowMark aria-hidden width="32" height="32" className={styles.pulse} />
  </div>
);

const LoadingLayer = () => (
  <LoadingMask>
    <LoadingIconWithContainer />
  </LoadingMask>
);

export default LoadingLayer;
